import { KeyDict } from "@/types/index"

export enum EventSheduleType {
  Scheduled = 'scheduled',
  Active = 'active',
  Completed = 'completed',
}

export interface EventDate {
  seconds: number,
  nanoseconds: number
}

// TODO check if this is the right type definition to be used inside eg EventList.vue
export interface CloudCastEvent {
  team_id: string,
  id: string,
  name?: string,
  asset_groups: KeyDict<boolean>,
  deleted: boolean,
  start_date: EventDate,
  end_date: EventDate
}

// in legacy code this is used for editing a CloudCastEvent
// but date types are incompatible
export class EditCloudCastEvent {
  '.uid'?: string = ''
  team_id: string = ''
  id?: string = ''
  name?: string = ''
  asset_groups?: KeyDict<boolean> = {}
  deleted: boolean = false
  start_date: Date | string = new Date()
  end_date: Date | string = new Date()
}
